import { z } from "zod";

import { Project } from "@/data/projects";

import { TimeReportProjectItem } from "./TimeReportProjectItem";

export const TimeReportProject = z
  .object({
    project: Project,
    projectName: z.string(),

    items: z.array(TimeReportProjectItem),
  })
  .passthrough();

export type TimeReportProject = z.infer<typeof TimeReportProject>;
